export const validationMsgs = {
  atLeastOne: 'Pelo menos um dos filtros deve ser preenchido',
  beneficiaryName: 'Nome incompleto',
  betweenOneYear: 'São permitidas apenas datas no período de até um ano',
  bothDateOrNone: 'As duas datas, ou nenhuma, devem ser selecionadas',
  requiredBoth: 'As duas datas devem ser selecionadas',
  bsDate: 'Data inválida',
  cellError: 'Número de celular inválido',
  cep: 'CEP inválido',
  checkCancellation: 'É obrigatório aceitar os termos para avançar',
  cpf: 'CPF inválido',
  cns: 'CNS inválido',
  cnpj: 'CNPJ inválido',
  cpfCnpj: 'CPF/CNPJ inválido',
  confirmPassword: 'Deve ser igual a nova senha',
  date: 'Data inválida',
  dateBigger: 'A data final deve ser posterior ou igual à data inicial',
  dateBiggerThanNow: 'A data deve ser posterior ou igual à data de hoje',
  dateBiggerThanThreeMonths: 'A data não pode ser anterior a três meses atrás',
  dateLess: 'A data deve ser anterior ou igual à data de hoje',
  dateStrictlyLess: 'A data deve ser anterior à data de hoje',
  email: 'E-mail inválido',
  emailOrCPF: 'E-mail ou CPF inválidos',
  equalToEmail: 'A confirmação de e-mail deve ser igual ao e-mail',
  equalToPassword: 'A confirmação de senha deve ser igual à senha',
  invalidAddress: 'Endereço inválido',
  invalidCellOrPhone: 'Telefone inválido',
  invalidName: 'Nome inválido',
  invalidUserOrPassword: 'Usuário ou senha inválidos',
  isBlacklisted: 'O campo contém palavras impróprias',
  minLengthTwo: 'A busca deve conter, pelo menos, dois caracteres',
  name: 'Nome completo obrigatório',
  notEqualToPassword: 'A senha atual não pode ser igual à nova senha.',
  no_plans_yet: 'Nenhum plano encontrado',
  no_tickets_yet: 'Não foram encontradas parcelas com possibilidade de gerar 2ª via.',
  no_requested_yet: 'Após realizar uma ou mais solicitações, você poderá acompanhá-las por aqui.',
  no_results: 'Não há resultados com o filtro utilizado',
  numberAccount: 'Número inválido',
  numberAgency: 'Número inválido',
  numberCount: 'Número inválido',
  numberBiggerZero: 'Número inválido',
  numberBiggerThanZero: 'O valor do campo deve ser superior a zero',
  password: 'Senha inválida',
  periodBiggerSixMonths: 'As datas não podem estar em um período maior que 6 meses',
  phoneError: 'Número de telefone inválido',
  required: 'Campo obrigatório',
  scrollCancellation: 'É obrigatório ler os termos até o final para avançar',
  valueConsultationInvalid: 'O valor do procedimento não pode ser zero',
  valueInvalid: 'Valor inválido',
  invalidUnimedCard: 'Cartão inválido',
  zip: 'O CEP inserido não foi encontrado',
};

export const apiErrorMsgs = (msg: string): string => {
  if (msg === 'não pode ser nulo') {
    return 'Campo obrigatório';
  } else {
    return msg;
  }
};

export const apiFieldErrorMsgs = {
  geocode: 'Geolocalização',
  ip: 'Ip',
};



// WEBPACK FOOTER //
// ./src/app/components/base/util/string.ts